import React, { useEffect, useMemo, useRef, useState } from "react";
import SavePropertyCard from "../common/SavePropertyCard/SavePropertyCard";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import { useNavigate } from "react-router-dom";
import Googlemap2 from "../common/GoogleMap/Googlemap2";
import { IoArrowBack } from "react-icons/io5";
import CollectionPropertyCard from "../Collections/CollectionPropertyCard";
import { toast } from "react-toastify";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Layout1 from "../../Layouts/Layout1";

function SavedPropertyCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl overflow-hidden border border-[#EAEAEA] animate-pulse">
      <div className="w-full h-56 bg-gray-200" />
      <div className="p-4 space-y-3">
        <div className="h-5 w-24 bg-gray-200 rounded" />
        <div className="h-4 w-full max-w-[180px] bg-gray-200 rounded" />
        <div className="h-3 w-full max-w-[140px] bg-gray-200 rounded" />
        <div className="flex gap-2 pt-2">
          <div className="h-4 w-14 bg-gray-200 rounded" />
          <div className="h-4 w-16 bg-gray-200 rounded" />
          <div className="h-4 w-12 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
}

const MySavedProperty = () => {
  const navigate = useNavigate();
  const AllTabs = ["All", "Buy", "Sold", "Rent"];
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    const getToken = localStorage.getItem("Token");
    if (getToken != null) {
      GetSavedProperty("");
    }
  }, []);

  const GetSavedProperty = async (isActive) => {
    setLoading(true);
    try {
      const res = await axiosInstanceAuth.post("savedProperty", {
        status: isActive,
      });
      const mydata = res?.data?.data;
      if (res?.data?.status) {
        setAllSavePropertyData(mydata);
      } else {
        toast.error("no data found!!");
        setAllSavePropertyData([]);
      }
    } catch {
      toast.error("Something went wrong");
      setAllSavePropertyData([]);
    } finally {
      setLoading(false);
    }
  };

  const [AllSavePropertyData, setAllSavePropertyData] = useState([]);

  function getPropertyStatus(p) {
    const s = (p?.status || "").toString().toLowerCase();
    if (s.includes("sold")) return "Sold";
    if (s.includes("active")) return "Buy";
    if (s.includes("rent") || s.includes("lease")) return "Rent";
    if (s.includes("inspect")) return "Inspected";
    return "Buy";
  }

  const filteredProperties = useMemo(() => {
    if (!Array.isArray(AllSavePropertyData)) return [];
    if (filter === "All") return AllSavePropertyData;
    return AllSavePropertyData.filter((p) => getPropertyStatus(p) === filter);
  }, [AllSavePropertyData, filter]);


  const gotoBack = () => {
    navigate("/dashboard");
  };


  return (
    <Layout1>
      <div className="container mx-auto py-10">
        <div className="flex flex-col gap-5">
          <button
            type="button"
            onClick={gotoBack}
            className="inline-flex items-center gap-1 text-[#097FE6] font-medium hover:underline"
          >
            <ChevronLeft className="w-5 h-5" strokeWidth={2} />
            Back to Dashboard
          </button>

          {/* <div className="flex items-center gap-2 mb-6">
            <button
              type="button"
              onClick={() => scrollStrip("prev")}
              className="p-2 rounded-xl bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 shrink-0"
              aria-label="Previous dates"
            >
              <ChevronLeft
                className="w-5 h-5 text-[#097FE6]"
                strokeWidth={3}
              />
            </button>
            <div
              ref={stripRef}
              className="flex gap-1 overflow-x-auto scroll-smooth py-2 scrollbar-hide flex-1"
              style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            >
              {dateStripDates.map((item) => {
                const key = `${item.full.getFullYear()}-${String(item.full.getMonth() + 1).padStart(2, "0")}-${String(item.full.getDate()).padStart(2, "0")}`;
                const isSelected = selectedDateKey === key;
                return (
                  <button
                    type="button"
                    key={key}
                    onClick={() => setSelectedDateKey(key)}
                    className={`shrink-0 flex flex-col gap-1 items-center justify-center min-w-[70px] min-h-[90px] py-2 px-2 rounded-xl border text-center transition-colors ${isSelected
                      ? "bg-[#097FE6] text-white border-gray-200 opacity-100"
                      : "bg-transparent opacity-50 border-gray-100 hover:opacity-70"
                      }`}
                  >
                    <span className="text-xl ">{item.date}</span>
                    <span className="text-base">{item.day}</span>
                  </button>
                );
              })}
            </div>
            <button
              type="button"
              onClick={() => scrollStrip("next")}
              className="p-2 rounded-xl bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 shrink-0"
              aria-label="Next dates"
            >
              <ChevronRight
                className="w-5 h-5 text-[#097FE6]"
                strokeWidth={3}
              />
            </button>
          </div>

          <div className="h-28 flex justify-start items-center gap-2 my-5 md:my-10 overflow-x-scroll py-2">
            <div className="h-full !min-w-[90px] grid place-content-center font-medium text-white text-lg md:text-xl lg:text-2xl bg-[#E5002A] rounded-lg cursor-pointer">
              All
            </div>
            {SelectedTime?.length > 0 &&
              SelectedTime?.map((d, index) => (
                <div
                  key={index}
                  className={`h-full !min-w-[90px] flex flex-col justify-center items-center gap-1 font-medium text-[#A3A3A3] text-base md:text-lg bg-white rounded-lg  cursor-pointer ${d?.selected ? ActiveTime : null
                    }`}
                  onClick={() => { }}
                >
                  <div>{d?.day}</div>
                  <div>{d?.date}</div>
                </div>
              ))}
          </div> */}
          {/* ------ Google Map ------ */}
          <div className="custStyle !relative ">
            <Googlemap2 location={AllSavePropertyData} />
          </div>

          {/* ------ Tabs ------ */}

          <div className="flex flex-wrap gap-2">
            {AllTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setFilter(tab)}
                className={`shrink-0 rounded-full px-5 py-2 text-sm font-medium transition text-[#000929] ${filter === tab
                  ? "bg-white border-2 border-[#000929]"
                  : "bg-white border border-gray-200 hover:border-gray-300"
                  }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* <SavePropertyCard
            SavePropertyData={AllSavePropertyData}
            GetSavedProperty={GetSavedProperty}
            isActive={isActive}
          /> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 overflow-y-auto">
            {loading ? (
              Array.from({ length: 4 }).map((_, i) => (
                <SavedPropertyCardSkeleton key={i} />
              ))
            ) : filteredProperties?.length > 0 ? (
              filteredProperties.map((item, index) => (
                <CollectionPropertyCard
                  key={item?._id ?? item?.id ?? index}
                  property={item}
                  isFavorite={item?.collections?.length > 0}
                  isAuthenticate={true}
                  setAuthPopUp={() => { }}
                  initialSelectedCollectionIds={item?.collections?.map((col) => col.id)}
                  onCreateNewCollection={() => { }}
                />
              ))
            ) : (
              <div className="col-span-full flex justify-center items-center min-h-[200px] rounded-2xl bg-[#E9EDF2] border border-gray-200 text-center px-6 py-12">
                <p className="text-[#000929] font-semibold">No saved properties found</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout1>
  );
};

export default MySavedProperty;
